module.exports = __webpack_public_path__ + "static/media/franceinter.29331387.png";